import { call, put, select } from "redux-saga/effects";
import { notify } from "../../../services/notification";
import api, { makeOptions, queryBuilder } from "../../../services/api";
import ActionsBranchRawInvoicesList from "../../ducks/branch-raw-invoices/list";

const getAuthData = (state) => state.auth.data;

export function* fetch(action) {
  try {
    const { params } = action;
    const query = params ? queryBuilder(params) : "";
    const url = `branch-raw-invoice?${query}`;
    const authData = yield select(getAuthData);
    const { data } = yield call(api.get, url, makeOptions(authData));

    yield put(ActionsBranchRawInvoicesList.success(data.branch_raw_invoices));
  } catch (err) {
    notify("error", err.response.data.error.message);
    yield put(
      ActionsBranchRawInvoicesList.failure(err.response.data.error.message)
    );
  }
}
